'use client'

import {getOrientation} from '@app/utils/orientation'
import {useParams, usePathname, useSearchParams} from 'next/navigation'
import {LanguageCodes} from '@app/i18n/settings'
import {getPathAlias, sessionStartQPKey} from '../helper'
import {useLayoutEffect, useState} from 'react'
import {useIsCanonicalHost} from '@app/components/session-attributes/use-is-canonical-host'
import {getQueryForCanonical} from '@app/components/session-attributes/get-query-for-canonical'
import {ReffererLayoutQueryName} from './constants'
import {USER_JOURNEY_GROUP} from '@app/constants/global'

const useCommonAttributesClient = () => {
  const {isExtendedCanonical} = useIsCanonicalHost()
  const params = useParams<{lang: LanguageCodes; gameName: string; gameCode: string}>()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const sessionStartPage = searchParams?.get(sessionStartQPKey) || getPathAlias(pathname || '')
  const [clientAttributes, setClientAttributes] = useState<null | Record<string, string | boolean>>(null)
  const reffererLayout = searchParams?.get(ReffererLayoutQueryName)

  useLayoutEffect(() => {
    const screenOrientation = getOrientation()
    const isPwaShortcut = window.matchMedia('(display-mode: standalone)').matches || false

    setClientAttributes({
      'screen-size': `${window.screen.width}x${window.screen.height}`,
      'viewport-size': `${window.innerWidth}x${window.innerHeight}`,
      'screen-orientation': screenOrientation,
      'page-route': decodeURIComponent(pathname || ''),
      'is-pwa-shortcut': isPwaShortcut,
      'session-start-screen': sessionStartPage,
      'page-name': getPathAlias(pathname || ''),
      'user-journey-group': USER_JOURNEY_GROUP,
      ...(reffererLayout && {[ReffererLayoutQueryName]: reffererLayout}),
      ...(isExtendedCanonical && {
        'session-start-screen': getQueryForCanonical(sessionStartQPKey),
      }),
    })
  }, [params?.lang, pathname, sessionStartPage, reffererLayout])

  return clientAttributes
}

export default useCommonAttributesClient
